const FacebookIcon = ({ size = 18 }: { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.25 8.66667H7V11.5H9.25V20H13V11.5H15.7L16 8.66667H13V7.4625C13 6.825 13.15 6.54167 13.825 6.54167H16V3H13.15C10.45 3 9.25 4.13333 9.25 6.25833V8.66667Z"
        fill="#0E0E0E"
      />
    </svg>
  );
};

export default FacebookIcon;
